import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { ChargeSuccessPage } from '@/features/coins/components/charge-success-page';

/** 토스 successUrl 쿼리 — 토스가 paymentKey·orderId·amount(·paymentType)를 붙여 돌려보낸다 */
const searchSchema = z.object({
  paymentKey: z.string().min(1).max(200).optional().catch(undefined),
  orderId: z.string().min(1).max(64).optional().catch(undefined),
  amount: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/_auth/charge/success')({
  validateSearch: searchSchema,
  // 토스가 붙인 값이 없으면 승인할 수 없다 — 직접 들어온 경우 충전 내역으로
  beforeLoad: ({ search }) => {
    if (!search.paymentKey || !search.orderId || search.amount === undefined) {
      throw redirect({ to: '/history', replace: true });
    }
  },
  staticData: { title: '결제 결과' },
  head: () => ({ meta: [{ title: '결제 결과 · 팬즈드롭 코인 충전' }] }),
  component: ChargeSuccessRoute,
});

function ChargeSuccessRoute() {
  const { paymentKey, orderId, amount } = Route.useSearch();
  if (!paymentKey || !orderId || amount === undefined) return null;
  return <ChargeSuccessPage paymentKey={paymentKey} orderId={orderId} amount={amount} />;
}
